<template>
    <IconLocation class="h-5 w-5 mt-1" />
    <div class="gap-20 text-sm text-grey-80">
        <div class="pt-1"> <!-- grid grid-flow-col grid-rows-1 grid-cols-5-->
            <template v-if="agency.promoted_agency">
                <p class="my-0" v-html="agency.specialist_serves_text"></p>
            </template>
            <template v-else>
                <p class="my-0" v-html="filterASCII(agency.branches[0].FullPostalAddress)">
                </p>
                <template v-if="isLocationPage && hasMoreBranches">
                    <p class="">+ {{ agency.branches.length }} other {{ pluralOffices }}</p>
                </template>
                <template v-else>
                    <div v-show="showOtherLocations" class="pt-1">
                        <ul v-if="showAddresses" class="address-list">
                            <li v-for="(branch, tag, idx) in addressesForListings(agency.branches.slice(1))" :key="tag"
                            v-html="filterASCII(branch)"></li>
                        </ul>
                        <ul v-else class="address-list">
                            <li v-html="filterASCII(branchLocations)"></li>
                        </ul>
                    </div>
                    <p v-if="hasMoreBranches" class="ml-0">
                        <button class="flex items-center text-blue-30" @click="toggleOtherLocations">
                            {{ buttonText }}
                            <span class="md:inline-flex chevron-icon">
                                <ChevronUp v-if="showOtherLocations" />
                                <ChevronDown v-else />
                            </span>
                        </button>
                    </p>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import IconLocation from 'Components/Icons/IconLocation';
import ChevronUp from 'Components/Icons/IconLocationChevronUp';
import ChevronDown from 'Components/Icons/IconLocationChevronDown';
import filterASCII from 'Mixins/text.js';

import { mapState, mapGetters } from 'vuex';

export default {
    name: 'AgencyAdvertAddress',
    components: { IconLocation, ChevronUp, ChevronDown },
    mixins: [filterASCII],
    data() {
        return {
            showOtherLocations: false,
            allowExpandExtraAddresses: false,
        };
    },
    computed: {
        ...mapState('search', ['static']),
        ...mapState('pagetext', ['pagetype']),
        ...mapGetters('pagetext', ['isLocationPage']),
        hasMoreBranches() {
            return this.agency.branches.length > 1;
        },
        showAddresses() {
            return this.agency.branches.length < 6;
        },
        pluralOffices() {
            return this.plural(this.agency.branches.length, 'office', 'offices');
        },
        buttonText() {
            const branchCount = this.agency.branches.length - 1;
            const locStr = this.plural(branchCount, 'location', 'locations');
            if (this.showOtherLocations) {
                return 'Show fewer locations';
            } else if (this.allowExpandExtraAddresses) {
                return `Show ${branchCount} additional ${locStr}`;
            } else {
                return `Plus ${branchCount} additional office ${locStr}`;
            }
        },
        branchLocations() {
            return Object.values(this.addressesForListings(this.agency.branches)).slice(1).sort().join(', ');
        }
    },
    props: {
        agency: { type: Object },
    },
    methods: {
        plural(c, sStr, pStr) {
            return (c == 1) ? "" + sStr : "" + pStr;
        },
        toggleOtherLocations() {
            this.showOtherLocations = !this.showOtherLocations;
        },
    },
    mounted() {
        this.allowExpandExtraAddresses = !this.static;
    },
    updated() {
        this.allowExpandExtraAddresses = !this.static;
    }
};
</script>
